import React from 'react';
import { Box, Button } from '@mui/material';
import { Description } from '@mui/icons-material';

import { useSelector } from 'react-redux';
import { selectOutlook } from '../store/slices/outlookSlice';
import { usePrint } from '../providers/PrintProvider';

/**
 * PrintButton - Print button component for generating PDF synthesis
 * Triggers print dialog with entity data and current outlook
 *
 * @param {Object} props - Component props
 * @param {string} props.code - Entity code (INSEE code)
 * @param {string} props.nom - Entity name
 * @returns {React.ReactElement} Print button with download action
 */
const PrintButton = ({ code, nom }) => {
  const { openPrintDialog } = usePrint();
  const outlook = useSelector(selectOutlook).value;

  const handlePrint = () => {
    openPrintDialog({
      code,
      name: nom,
      outlook
    });
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Button
        variant="contained"
        color="secondary"
        size="small"
        onClick={handlePrint}
        endIcon={<Description />}
        sx={{
          borderRadius: 15,
          width: 240,
          textTransform: 'uppercase',
          px: 1,
          py: 0.5,
        }}
      >
        Télécharger la synthèse
      </Button>
    </Box>
  );
};

PrintButton.displayName = 'PrintButton';

export default React.memo(PrintButton);
